import { render, staticRenderFns } from "./SendMessageTargetFamilyRow.vue?vue&type=template&id=6b2b7ae6&scoped=true&lang=pug"
import script from "./SendMessageTargetFamilyRow.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetFamilyRow.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetFamilyRow.vue?vue&type=style&index=0&id=6b2b7ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b7ae6",
  null
  
)

export default component.exports